const ProfileImageItem = ({ onImageSelect, index, image, onImageRemove }: any) => {
    const handleImage = (e: any) => {
        onImageSelect(e, index);
    };

    const handleRemoveImage = () => {
        onImageRemove(index);
    };

    return (
        <div className='col-6 col-sm-4'>
            <div className='imageUpload'>
                {image?.file_path != null ? (
                    <>
                        <img src={typeof image?.file_path == "string" ? image?.file_path : URL.createObjectURL(image?.file_path)} alt={`Selected Image`} />
                        <button type="button" className='deleteBTN' onClick={handleRemoveImage}>
                            <span className="icon-close-line"></span>
                        </button>
                    </>
                ) : (
                    <>
                        <span className="icon-upload"></span>
                        <input
                            type='file'
                            className='form-control'
                            onChange={handleImage}
                            accept="image/jpeg,image/jpg,image/png,image/JPEG,image/JPG,image/PNG"
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default ProfileImageItem;
